export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";